import tasksEditor from './tasksEditor.json';
import workspaceResize from './workspaceResize.json';
import workspaceV2 from './workspaceV2.json';
import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import aiAgents from './aiAgents.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import automationEvents from './automationEvents.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import dock from './dock.json';
import companies from './companies.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import contentTemplates from './contentTemplates.json';
import conversation from './conversation.json';
import emailSequences from './emailSequences.json';
import emailFlowAddMenu from './emailFlowAddMenu.json';
import emailFlowFunnel from './emailFlowFunnel.json';
import emailEditor from './emailEditor.json';
import emailSequenceFlowRecovery from './emailSequenceFlowRecovery.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxConnectionHealth from './inboxConnectionHealth.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import internalChat from './internalChat.json';
import mfa from './mfa.json';
import onboarding from './onboarding.json';
import onboardingManual from './onboardingManual.json';
import onboardingVisor from './onboardingVisor.json';
import releaseNotes from './releaseNotes.json';
import planos from './planos.json';
import sessionLimit from './sessionLimit.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import executionDetail from './executionDetail.json';
import conversationWorkflowEditor from './conversationWorkflowEditor.json';
import signup from './signup.json';
import sla from './sla.json';
import snooze from './snooze.json';
import teamsSettings from './teamsSettings.json';
import webhooks from './webhooks.json';
import whatsappTemplates from './whatsappTemplates.json';
import kanban from './kanban.json';
import kanbanSharing from './kanbanSharing.json';
import scheduleMessages from './scheduleMessages.json';
import voipDisposition from './voipDisposition.json';
import voipSettings from './voipSettings.json';
import voipCalls from './voipCalls.json';
import yearInReview from './yearInReview.json';
import settingsCenter from './settingsCenter.json';
import aiCenterShell from './aiCenterShell.json';
import aiCenterQueue from './aiCenterQueue.json';
import aiCenterItem from './aiCenterItem.json';
import aiSettings from './aiSettings.json';

export default {
  ...tasksEditor,
  ...workspaceResize,
  ...workspaceV2,
  ...advancedFilters,
  ...agentBots,
  ...aiAgents,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...automationEvents,
  ...bulkActions,
  ...campaign,
  ...emailSequences,
  ...emailFlowAddMenu,
  ...emailFlowFunnel,
  ...emailEditor,
  ...emailSequenceFlowRecovery,
  ...cannedMgmt,
  ...chatlist,
  ...dock,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...contentTemplates,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxConnectionHealth,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...internalChat,
  ...mfa,
  ...onboarding,
  ...onboardingManual,
  ...onboardingVisor,
  ...releaseNotes,
  ...planos,
  ...sessionLimit,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...executionDetail,
  ...conversationWorkflowEditor,
  ...signup,
  ...sla,
  ...snooze,
  ...teamsSettings,
  ...webhooks,
  ...whatsappTemplates,
  ...kanban,
  ...kanbanSharing,
  ...scheduleMessages,
  ...voipDisposition,
  ...voipSettings,
  ...voipCalls,
  ...yearInReview,
  ...settingsCenter,
  ...aiCenterShell,
  ...aiCenterQueue,
  ...aiCenterItem,
  ...aiSettings,
};
